<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false"
      :color="this.$primaryColor"
    ></loading>
    <p class="text-center font-bold">
      Select an image file and perform face detection and analysis
    </p>
    <div class="mt-6 flex justify-around">
      <div>
        <div>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="image1"
              type="file"
              name="image1"
              accept="image/*"
              required
              class="w-full"
              @change="assingImgInput"
            />
          </div>
          <div class="error" v-if="errors.image1">
            {{ errors.image1 }}
          </div>
        </div>
        <div class="text-center">
          <button
            class="
              justify-center
              cursor-pointer
              inline-flex
              px-4
              py-2
              text-base
              transition
              duration-150
              ease-in-out
              border border-gray-600
              rounded-md
              mt-3
            "
            @click="takePhoto"
          >
            Or Take Photo
          </button>
          <div class="max-w-xs max-h-full mt-3 mx-auto relative">
            <img
              :src="
                imagePoints == null
                  ? img1
                  : 'data:image/png;base64,' + imagePoints
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-6">
      <button class="btn-primary" @click="process()">Process</button>
    </div>

    <modal :show="showWebCam" @closeModal="closeModal()">
      <webcam :showCam="showWebCam" @img="setImg" />
    </modal>

    <div
      class="
        mt-8
        max-w-md
        mx-auto
        text-center
        border border-primary-color
        rounded-md
        pb-4
      "
      style="background-color: aliceblue"
      v-if="metrics"
    >
      <div
        class="
          w-full
          flex
          h-12
          justify-center
          items-center
          mb-4
          border-b border-primary-color
          font-bold
        "
      >
        <p
          class="flex-1 flex justify-center items-center h-full cursor-pointer"
          :class="menu == 1 && 'bg-primary-300'"
          @click="menu = 1"
        >
          Quality Metrics
        </p>
        <p
          class="flex-1 flex justify-center items-center h-full cursor-pointer"
          :class="menu == 2 && 'bg-primary-300'"
          @click="menu = 2"
        >
          JSON
        </p>
      </div>
      <div v-if="menu == 1">
        <div
          class="flex justify-center space-x-2 mt-1"
          v-for="(metric, index) in metrics"
          :key="index"
        >
          <p>{{ metric.name }}:</p>
          <p :class="metric.test ? 'text-emerald-500' : 'text-red-500'">
            {{ metric.value.toFixed(2) }}
          </p>
        </div>
      </div>
      <pre class="text-xs text-left pl-2" v-if="menu == 2"
        >{{ jsonBeautify }}
      </pre>
    </div>
  </div>
</template>

<script>
import webcam from "../../Components/webCam.vue";
import modal from "../../Components/modal.vue";

export default {
  components: { webcam, modal },
  props: ["option"],
  data() {
    return {
      errors: {
        image1: null,
      },
      showWebCam: false,
      img1: null,
      imagePoints: null,
      score: null,
      loading: false,
      metrics: null,
      jsonBeautify: null,
      menu: 1,
    };
  },
  created() {},
  methods: {
    takePhoto() {
      this.showWebCam = true;
    },
    closeModal() {
      this.showWebCam = false;
    },
    setImg(img) {
      this.img1 = img;
      this.errors.image1 = null;
      this.showWebCam = false;
      this.process();
    },
    process() {
      if (this.img1 == null) {
        this.errors.image1 = "Image required";
        return;
      }
      this.errors.image1 = null;

      this.loading = true;
      this.axios
        .post("/user/api/face/process", {
          img1: this.img1,
          option: this.option,
        })
        .then((response) => {
          this.loading = false;
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
          } else {
            let data = response.data[0];
            delete data.template;
            delete data.template_version;
            delete data.matching_image;
            this.metrics = data.quality_metrics;
            this.imagePoints = data.image_points;
            delete data.image_points;
            this.jsonBeautify = JSON.stringify(data, undefined, 4);
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        });
    },
    async assingImgInput(event) {
      let imgBase64 = await this.getBase64(event.target.files[0]);
      this.setImg(imgBase64);
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>
